/**
 * Rebuy search recommendations (widget 301668).
 * Predictive search replaces results via Ajax innerHTML, so we re-init
 * the mount after every search:results-updated (and on DOM ready).
 *
 * After products render, collapse Flickity/flex stretch that leaves a huge
 * gap above ATC (same class of bug as the cart-drawer Rebuy cards).
 * Do NOT mutate Rebuy widget settings — that can empty the widget.
 */
(function () {
  var SEARCH_WIDGET_ID = '301668';
  var STYLE_ID = 'rebuy-search-compact-override';
  var lastSeedKey = '';

  function widgetId(widget) {
    return widget && widget.id != null ? String(widget.id) : '';
  }

  function isSearchWidget(widget) {
    return widgetId(widget) === SEARCH_WIDGET_ID;
  }

  function refreshNativeCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false, skipLoadingStart: true }
      })
    );
  }

  function openNativeCartDrawer() {
    if (typeof window.__warehouseOpenCartDrawer === 'function') {
      window.__warehouseOpenCartDrawer();
      return;
    }

    var miniCart = document.getElementById('mini-cart');
    if (miniCart && miniCart.getAttribute('aria-hidden') !== 'false') {
      var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
      if (toggle) toggle.click();
    }
  }

  function getSearchMount() {
    return document.querySelector(
      '.search-bar__rebuy[data-rebuy-id="' + SEARCH_WIDGET_ID + '"], [data-rebuy-id="' + SEARCH_WIDGET_ID + '"]'
    );
  }

  function mountSeedKey(mount) {
    if (!mount) return '';
    return (
      (mount.getAttribute('data-rebuy-shopify-product-ids') || '') +
      '|' +
      (mount.getAttribute('data-rebuy-id') || '')
    );
  }

  function ensureOverrideStylesheet() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-grid {',
      '  display: flex !important;',
      '  flex-flow: row wrap !important;',
      '  align-items: flex-start !important;',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '}',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-block,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-grid[class*="columns-"] .rebuy-product-block {',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '  max-height: none !important;',
      '  align-self: flex-start !important;',
      '  justify-content: flex-start !important;',
      '}',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-info,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-actions,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-options,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-controls {',
      '  flex: 0 0 auto !important;',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '}',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-actions,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-options,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .rebuy-product-controls {',
      '  margin-top: 8px !important;',
      '}',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .flickity-viewport,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .flickity-enabled,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .splide,',
      '.search-bar__rebuy #rebuy-widget-' + SEARCH_WIDGET_ID + ' .splide__track {',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '  max-height: none !important;',
      '  overflow: visible !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function forceCompactSearchCards() {
    ensureOverrideStylesheet();

    var root = document.getElementById('rebuy-widget-' + SEARCH_WIDGET_ID);
    if (!root) return;

    // Only touch layout once products exist — never reconfigure Rebuy itself.
    if (!root.querySelector('.rebuy-product-block')) return;

    root.querySelectorAll('.rebuy-product-grid').forEach(function (grid) {
      grid.className = grid.className
        .replace(/\b(large|medium|small)-columns-\d+\b/g, '')
        .replace(/\b(large|medium|small)-style-(line|list)\b/g, '')
        .replace(/\b(large|medium|small)-carousel\b/g, '')
        .replace(/\s+/g, ' ')
        .trim();

      grid.classList.add('large-columns-4', 'medium-columns-3', 'small-columns-2');

      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-flow', 'row wrap', 'important');
      grid.style.setProperty('align-items', 'flex-start', 'important');
      grid.style.setProperty('height', 'auto', 'important');
      grid.style.setProperty('min-height', '0', 'important');
      grid.style.setProperty('transform', 'none', 'important');
      grid.style.setProperty('left', 'auto', 'important');

      grid.querySelectorAll('.rebuy-product-block').forEach(function (el) {
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('align-self', 'flex-start', 'important');
        el.style.setProperty('justify-content', 'flex-start', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('left', 'auto', 'important');
        el.style.setProperty('top', 'auto', 'important');
      });

      grid.querySelectorAll('.rebuy-product-image, .rebuy-product-media').forEach(function (el) {
        el.style.setProperty('height', '100px', 'important');
        el.style.setProperty('max-height', '100px', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('flex', '0 0 auto', 'important');
      });

      grid.querySelectorAll('.rebuy-product-info, .rebuy-product-actions, .rebuy-product-options, .rebuy-product-controls').forEach(function (el) {
        el.style.setProperty('flex', '0 0 auto', 'important');
        el.style.setProperty('min-height', '0', 'important');
        el.style.setProperty('height', 'auto', 'important');
      });

      grid.querySelectorAll('.rebuy-product-actions, .rebuy-product-options, .rebuy-product-controls').forEach(function (el) {
        el.style.setProperty('margin-top', '8px', 'important');
      });

      grid.querySelectorAll('.rebuy-button').forEach(function (el) {
        el.style.setProperty('margin', '0', 'important');
      });
    });

    root.querySelectorAll('.flickity-viewport, .flickity-enabled, .splide, .splide__track').forEach(function (el) {
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('min-height', '0', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
    });
  }

  function scheduleCompact() {
    forceCompactSearchCards();
    setTimeout(forceCompactSearchCards, 50);
    setTimeout(forceCompactSearchCards, 250);
  }

  function initSearchRebuy() {
    var mount = getSearchMount();
    if (!mount) return;

    // Prefer a single init path. Do not also call widget.call() after
    // Rebuy.init() — that was wiping the search recommendations.
    try {
      if (window.Rebuy && typeof window.Rebuy.init === 'function') {
        window.Rebuy.init();
        scheduleCompact();
        return;
      }
    } catch (e) {}

    try {
      if (window.rebuy && typeof window.rebuy.init === 'function') {
        window.rebuy.init();
        scheduleCompact();
        return;
      }
    } catch (e) {}

    try {
      if (window.Rebuy && window.Rebuy.widgets && typeof window.Rebuy.widgets === 'object') {
        var widgets = window.Rebuy.widgets;
        var id = SEARCH_WIDGET_ID;
        var list = Array.isArray(widgets) ? widgets : Object.keys(widgets).map(function (key) {
          return widgets[key];
        });

        list.forEach(function (widget) {
          if (widgetId(widget) !== id) return;
          if (typeof widget.call === 'function') {
            widget.call();
          } else if (typeof widget.init === 'function') {
            widget.init();
          } else if (typeof widget.render === 'function') {
            widget.render();
          }
        });
      }
    } catch (e) {}

    scheduleCompact();
  }

  var scheduled = false;
  function scheduleInit(force) {
    var mount = getSearchMount();
    if (!mount) return;

    var seedKey = mountSeedKey(mount);
    // Avoid re-init loops when Rebuy mutates its own DOM under the mount.
    if (!force && seedKey && seedKey === lastSeedKey) {
      scheduleCompact();
      return;
    }
    lastSeedKey = seedKey;

    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initSearchRebuy();
    });
  }

  document.documentElement.addEventListener('search:results-updated', function () {
    lastSeedKey = '';
    scheduleInit(true);
  });
  document.addEventListener('DOMContentLoaded', function () {
    scheduleInit(true);
  });

  document.addEventListener('rebuy.ready', function (event) {
    if (isSearchWidget((event.detail || {}).widget)) {
      scheduleCompact();
    }
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    if (isSearchWidget((event.detail || {}).widget)) {
      scheduleCompact();
    }
  });

  document.addEventListener('rebuy.add', function (event) {
    var detail = event.detail || {};
    if (widgetId(detail.widget) !== SEARCH_WIDGET_ID) return;
    refreshNativeCart();
    openNativeCartDrawer();
  });

  // Detect Ajax-injected mounts without re-initing on every Rebuy child mutation.
  if (typeof MutationObserver !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      var resultsInner = document.querySelector('.search-bar__results-inner');
      if (!resultsInner) return;

      var observer = new MutationObserver(function () {
        var mount = getSearchMount();
        if (!mount) {
          lastSeedKey = '';
          return;
        }
        scheduleInit(false);
      });

      observer.observe(resultsInner, { childList: true, subtree: true });
    });
  }
})();
